import script from "./AssetProcessingTechniqueProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssetProcessingTechniqueProperties.vue?vue&type=script&setup=true&lang=ts"

import "./AssetProcessingTechniqueProperties.vue?vue&type=style&index=0&id=3d2365ca&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d2365ca"]])

export default __exports__